export default __webpack_public_path__ + "static/media/rp29.743b0d67.jpg";